<template>
    <div>
        <v-card width="400" class="mx-auto ma-4">
            <v-card-title>
                Logga in
            </v-card-title>
            <v-card-text>
                Logga in för att fortsätta.
                <div id="firebaseui-auth-container"></div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import * as firebaseui from 'firebaseui'

export default {
    name: 'LogIn',
    mounted() {
        const uiConfig = {
            signInSuccessUrl: '/',
            signInOptions: [
                firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            ],
            tosUrl: null,
            privacyPolicyUrl: null,
        };

        // Initialize the FirebaseUI Widget using Firebase.
        const ui = new firebaseui.auth.AuthUI(firebase.auth());
        // The start method will wait until the DOM is loaded.
        ui.start('#firebaseui-auth-container', uiConfig);
    }
}
</script>
